import { useRuntimeStore } from '@/store/runtime'

export default function user_flag (flag) {
    // all groups are required
    const runtimeStore = useRuntimeStore()
    if (!runtimeStore.session.user) return false

    // console.log("---user_flag---")
    // console.log(flag)
    // console.log(runtimeStore.session.user)

    if (flag in runtimeStore.session.user) {
        return runtimeStore.session.user[flag] === true
    }

}
